import axios from "axios";
import { appConfig } from "@quest/appConfig";
import { keycloak } from "@quest/keycloakConfig";

class MaintenanceService {
  async getMaintenanceStatus() {
    const response = await axios.get(`${appConfig.apiUrl}/maintenance/status`);
    return response.data;
  }

  async toggleMaintainance() {
    const response = await axios.put(
      `${appConfig.apiUrl}/maintenance/toggle`,
      {
        withCredentials: true,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${keycloak.token}`,
        },
      }
    );
    return response.data;
  }
}

export const maintenanceService = new MaintenanceService();
